import { estada } from "../apis/core-api";
import Extensions_Registry from "./Extensions_Registry";

export default async function getExtensionInstance(name: string): Promise<estada.IExtensionInstance | undefined> {

    const loader = Extensions_Registry[name];
    if (!loader) return undefined;

    const mod = await loader();
    return mod.default();
}
